import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/get-users-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchUserListContext } from '../../user.context';
import { UserListFilterSearchFormStep1Controller } from '../user-list-filter-search-form-step-1/user-list-filter-search-form-step-1.controller';

export interface UserListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetUsersPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetUsersPaginatedModel>;
  onCancel: () => void;
}

export const UserListFilterSearchFormController = (
  props: UserListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchUserListContext();

  return (
    <HeadlessFormProvider<GetUsersPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <UserListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
